export var EMobileImagePosition = /* @__PURE__ */ ((EMobileImagePosition2) => {
  EMobileImagePosition2["TOP"] = "TOP";
  EMobileImagePosition2["BOTTOM"] = "BOTTOM";
  return EMobileImagePosition2;
})(EMobileImagePosition || {});
export var EDesktopLayout = /* @__PURE__ */ ((EDesktopLayout2) => {
  EDesktopLayout2["HORIZONTAL"] = "horizontal";
  EDesktopLayout2["VERTICAL"] = "vertical";
  return EDesktopLayout2;
})(EDesktopLayout || {});
export var EDesktopImagePosition = /* @__PURE__ */ ((EDesktopImagePosition2) => {
  EDesktopImagePosition2["LEFT"] = "LEFT";
  EDesktopImagePosition2["RIGHT"] = "RIGHT";
  return EDesktopImagePosition2;
})(EDesktopImagePosition || {});
